<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{
          $t(
            'administration.mobile_feature.notification.template_setup.template_setup'
          )
        }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t(
              'administration.mobile_feature.notification.template_setup.template_setup'
            ),
            href: '/notification-templates'
          },
          {
            text: $t(
              'administration.mobile_feature.notification.template_setup.edit'
            ),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="row m-b-10">
              <div class="col-md-12">
                <label>
                  {{
                    $t(
                      'administration.mobile_feature.notification.template_setup.notification_type'
                    )
                  }}
                  <span class="text-danger">*</span>
                </label>
                <select
                  v-model.number="model.not_type_id"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('not_type_id') }"
                  @change="getNotificationParams"
                >
                  <option value="">{{ $t('select') }}</option>
                  <option
                    v-for="(notification_type, index) in notification_types"
                    :key="index"
                    :value="notification_type.not_type_id"
                  >
                    {{ notification_type.not_type }}
                  </option>
                </select>
                <div class="invalid-feedback" v-if="errors.has('not_type_id')">
                  {{ errors.first('not_type_id') }}
                </div>
              </div>
            </div>
            <div class="row m-b-10">
              <div class="col-md-12">
                <label>
                  {{
                    $t(
                      'administration.mobile_feature.notification.template_setup.subject'
                    )
                  }}
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  v-model.trim="model.not_subject"
                  class="form-control kh-font"
                  :class="{ 'is-invalid': errors.has('not_subject') }"
                />
                <div class="invalid-feedback" v-if="errors.has('not_subject')">
                  {{ errors.first('not_subject') }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label>
                  {{
                    $t(
                      'administration.mobile_feature.notification.template_setup.status'
                    )
                  }}
                  <span class="text-danger">*</span>
                </label>
                <select
                  v-model.number="model.spare1"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('spare1') }"
                  :disabled="model.not_type_id != 2"
                >
                  <option value="">{{ $t('select') }}</option>
                  <option value="All">{{
                    $t('notificationtemplate.all')
                  }}</option>
                  <option value="Present">{{
                    $t('notificationtemplate.present')
                  }}</option>
                  <option value="Absent">{{
                    $t('notificationtemplate.absent')
                  }}</option>
                </select>
                <span style="color:#c4c4c4"
                  ><small>
                    {{
                      $t(
                        'administration.mobile_feature.notification.template_setup.only_avalidable_for_class_attendance'
                      )
                    }}
                  </small></span
                >
                <div class="invalid-feedback" v-if="errors.has('spare1')">
                  {{ errors.first('spare1') }}
                </div>
              </div>
            </div>
          </ts-card-wrapper>
        </ts-card>
        <br />
        <ts-card>
          <ts-card-wrapper>
            <h5 style="color:gray">
              {{
                $t(
                  'administration.mobile_feature.notification.template_setup.parameters'
                )
              }}
            </h5>
            <small>
              {{
                $t(
                  'administration.mobile_feature.notification.template_setup.just_click_to_copy_the_parameter'
                )
              }}
            </small>
            <hr style="margin-bottom:5px;" />
            <div class="row">
              <div
                class="col-md-6"
                v-for="(notification_param, index) in notification_params"
                :key="index"
                @click.stop="copyText(notification_param.param_name, index)"
              >
                <label class="parameter">
                  {{ notification_param.param_name }}
                  <span class="copied" v-if="index === copied"
                    ><small>{{
                      $t('notificationtemplate.copied')
                    }}</small></span
                  >
                </label>
              </div>
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-9 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <ts-tabs target="gTab">
              <ts-tab>{{
                $t(
                  'administration.mobile_feature.notification.template_setup.device_template'
                )
              }}</ts-tab>
              <ts-tab>
                <span :class="{ 'text-danger': errors.has('content_en') }">
                  {{
                    $t(
                      'administration.mobile_feature.notification.template_setup.email_template'
                    )
                  }}
                </span>
              </ts-tab>
            </ts-tabs>
            <ts-tab-panes name="gTab">
              <ts-tab-pane>
                <VueEditor
                  ref="device_template"
                  v-model="model.device_template"
                  :editor-toolbar="customMobileToolbar"
                />
              </ts-tab-pane>
              <ts-tab-pane>
                <VueEditor
                  ref="email_template"
                  v-model="model.email_template"
                  :editor-toolbar="customToolbar"
                  useCustomImageHandler
                  @imageAdded="handleImageAdded"
                />
              </ts-tab-pane>
            </ts-tab-panes>
            <div class="row">
              <div class="col-sm-4 text-left mt-2">
                <label
                  v-if="errors.has('email_template')"
                  :class="{ 'text-danger': errors.has('email_template') }"
                >
                  {{ errors.first('email_template') }}
                </label>
                <label
                  v-if="errors.has('device_template')"
                  :class="{ 'text-danger': errors.has('device_template') }"
                >
                  {{ errors.first('device_template') }}
                </label>
              </div>
              <div class="col-sm-8 text-right mt-2">
                <ts-button
                  class="btn-primary mt-2"
                  @click.prevent="update"
                  :waiting="waiting"
                  >{{ $t('update') }}</ts-button
                >
                <ts-button
                  class="mt-2 ml-2"
                  @click="$router.push({ name: 'notification-template' })"
                  >{{ $t('cancel') }}</ts-button
                >
              </div>
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import { VueEditor } from 'vue2-editor'
import { isEmpty } from 'lodash'

export default {
  name: 'news-edit',
  components: { VueEditor },
  data() {
    return {
      model: {
        not_template_id: '',
        not_type_id: '',
        not_subject: '',
        device_template: '',
        email_template: '',
        spare1: ''
      },
      waiting: false,
      errors: new Errors(),
      copied: '',
      customToolbar: [
        [{ font: [] }],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        [{ header: 1 }, { header: 2 }],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ color: [] }, { background: [] }],
        ['link', 'image'],
        [{ direction: 'rtl' }],
        ['clean']
      ],
      customMobileToolbar: [
        [{ font: [] }],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        [{ header: 1 }, { header: 2 }],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ color: [] }, { background: [] }],
        ['link'],
        [{ direction: 'rtl' }],
        ['clean']
      ]
    }
  },
  created() {
    this.setEditData()
    this.$store.commit('notificationTemplate/SET_NOTIFICATION_PARAMS', [])
  },
  computed: {
    ...mapState('notificationTemplate', [
      'notification_types',
      'notification_params',
      'edit_data'
    ])
  },
  methods: {
    copyText(value, index) {
      this.$copyText(value).then(() => {
        this.copied = index
      })
    },
    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      var formData = new FormData()
      formData.append('image_content', file)
      this.$store
        .dispatch('notificationTemplate/imageContent', formData)
        .then(response => {
          Editor.insertEmbed(cursorLocation, 'image', response)
          resetUploader()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    getNotificationParams() {
      this.copied = ''
      this.model.spare1 = this.model.not_type_id == 2 ? this.model.spare1 : ''
      if (this.model.not_type_id) {
        this.$store.dispatch(
          'notificationTemplate/notificationParams',
          this.model.not_type_id
        )
      } else {
        this.$store.commit('notificationTemplate/SET_NOTIFICATION_PARAMS', [])
      }
    },
    setEditData() {
      this.model.not_template_id = this.edit_data.not_template_id
      this.model.not_type_id = this.edit_data.not_type_id
      this.model.not_subject = this.edit_data.not_subject
      this.model.device_template = this.edit_data.device_template
      this.model.email_template = this.edit_data.email_template
      this.model.spare1 = this.edit_data.spare1
      this.getNotificationParams()
    },
    async update() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('notificationTemplate/update', Object.assign({}, this.model))
        .then(response => {
          this.waiting = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'notification-template' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    }
  },
  beforeRouteLeave(to, from, next) {
    if (isEmpty(to.params)) {
      this.$store.commit('notificationTemplate/RESET_STATE')
      this.$store.commit('notificationTemplate/SET_EDIT_DATA', {})
    }
    next()
  }
}
</script>
<style>
.ql-editor {
  min-height: 23vh !important;
  height: 64vh !important;
  overflow-y: scroll !important;
}
</style>

<style lang="css" scoped>
.parameter {
	background-color: linen;
	padding: 5px 12px;
	border-radius: 3px;
	cursor: pointer;
	margin-bottom: 0 !important;
	margin-top:10px;
}
.parameter:active {
  background-color: rgb(146, 146, 146);
}
.copied {
  color: #fff;
  background: #348fe2;
  padding: 0 2px;
  border-radius: 3px;
  font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
}
</style>
